import type { HTMLAttributes } from 'react';

export type ColumnSize = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface FlexGridItemProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Whether or not the flex grid item has a maximum width
   */
  hasMaximumWidth?: boolean;

  /**
   * Set the xs breakpoint column size
   */
  xs?: ColumnSize;

  /**
   * Set the sm breakpoint column size
   */
  sm?: ColumnSize;

  /**
   * Set the md breakpoint column size
   */
  md?: ColumnSize;

  /**
   * Set the lg breakpoint column size
   */
  lg?: ColumnSize;

  /**
   * Set the lgP breakpoint column size
   */
  lgP?: ColumnSize;

  /**
   * Set the xl breakpoint column size
   */
  xl?: ColumnSize;

  /**
   * Set the data-testid attribute
   */
  testid?: string;
}

export const isColumnSize = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columnSize: number | any
): columnSize is ColumnSize =>
  typeof columnSize === 'number' && columnSize >= 0 && columnSize <= 12;
